import {useEffect, useState} from 'react';

import {REDESIGN_DRAWER_TRANSITION_MS} from 'llm/chat-library/ui/AIStyleConstants';
import type {Routine} from 'llm/routines/RoutineTypes';

/**
 * Owns the "view all agents" overlay state for a redesigned-sidebar host (wide column or semi-expanded
 * dropdown). Closing the drawer dismisses the overlay so reopening lands on the normal sidebar; the
 * reset is deferred until the drawer's close animation finishes (so the swap isn't visible mid-close)
 * and is cancelled if the drawer reopens within that window.
 *
 * Returns the ordered routines to show (null = closed) and a setter the strip's "view all" control
 * calls with the ordered list.
 */
export default function useDeferredAgentsPanelReset(
  isDrawerOpen: boolean
): readonly [Array<Routine> | null, (routines: Array<Routine> | null) => void] {
  const [agentsPanelRoutines, setAgentsPanelRoutines] = useState<Array<Routine> | null>(null);
  useEffect(() => {
    if (isDrawerOpen) {
      return undefined;
    }
    const timer = setTimeout(() => {
      setAgentsPanelRoutines(null);
    }, REDESIGN_DRAWER_TRANSITION_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [isDrawerOpen]);
  return [agentsPanelRoutines, setAgentsPanelRoutines];
}
